import ProductRecommendations from "./ProductRecommendations";
import ProductRecommendationTypes from "./ProductRecommendationTypes";

export { ProductRecommendationTypes };
export default ProductRecommendations;
